import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
export const MyModal = ({ handleOpen, handleClose, rows, title, Save, size, formik, extraButton, cancelReset, closeReset, fullScreen, scroll, style, modalStyle = false }) => {
    return (<Dialog open={handleOpen} onClose={handleClose} onClick={(event) => event.stopPropagation()} disableEscapeKeyDown maxWidth={size} scroll={scroll || "paper"} fullScreen={fullScreen ? true : false} >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={style ? { background: 'rgb(112 112 92 / 83%)' } : modalStyle ? { background: '#fff', width: 650 } : { background: '#fff' }}>
            <form>{rows}</form>
        </DialogContent>
        <DialogActions>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <div>{extraButton}</div>
                <div>
                    {!cancelReset && <Button onClick={() => formik.resetForm()} variant="outlined" color="primary">Reset</Button>}
                    {!closeReset && <Button onClick={handleClose} variant="outlined" color="error" sx={{ mx: 1 }}>Cancel</Button>}
                    {Save}
                </div>
            </div>
        </DialogActions>
    </Dialog>)
}
